import './styles/main.scss';
import { Dropdown } from 'bootstrap';
import '../assets/scripts/sliders.js';
import '../assets/scripts/animations.js';
import '../assets/scripts/navbar.js';
import '../assets/scripts/audio.js';
import '../assets/scripts/flip-card.js';
import '../assets/scripts/ajax.js';
import '../assets/scripts/filters.js';

const eventHTMLMessage = `
<div class="d-flex justify-content-between align-items-center py-2 px-3 flex-column flex-lg-row">
  <p>Notre agence est fermée du 3 au 14 Août 2026 inclus, mais vous pouvez toujours envoyer vos campagne sur l'Interphone !</p>
  <div class="d-flex align-items-center gap-2">
    <a href="https://interphone.phone-contact.com/login" target="_blank" class="btn btn-primary rounded-3">Connexion</a>
    <a href="https://interphone.phone-contact.com/demande-inscription" target="_blank" class="btn btn-secondary rounded-3">Inscription</a>
    <button type="button" class="close">x</button>
  </div>
</div>`;
const eventActive = true;
const eventBegin = "01/08/2026";
const eventEnd = "16/08/2026";
const eventName = "Fermeture Aout 2026";

document.addEventListener('DOMContentLoaded', () => {
  // Initialisation du carousel et import du javascript quand c'est nécessaire
  if (document.querySelector('.splide')) {
    import('../assets/scripts/splide-4.1.3/dist/js/splide.min.js').then(() => {
      import('../assets/scripts/carousels.js').then(({ initCarousels }) => {
        initCarousels();
      });
    });
  }

  // Appel du composant d'évent quand on en a besoin
  if(eventActive){
    function parseFrDate(str) {
      const [day, month, year] = str.split("/").map(Number);
      return new Date(year, month - 1, day); // month - 1 car les mois JS commencent à 0
    }
  
    const begin = parseFrDate(eventBegin);
    const end = parseFrDate(eventEnd);
    const now = new Date();
  
    // On compare uniquement les jours (sans l'heure) pour éviter les effets de bord
    begin.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999); // fin de journée incluse
    now.setHours(12, 0, 0, 0);

    const shouldListen = shouldListenEventToday(eventName);

    if(now >= begin && now <= end && shouldListen){
      document.querySelector("body").insertAdjacentHTML("beforeend", '<div class="event d-none"></div>');
      const eventBlock = document.querySelector(".event");

      eventBlock.innerHTML = eventHTMLMessage;
      eventBlock.classList.remove("d-none");
      setTimeout(() => {
        eventBlock.classList.add("shown");
      }, 400);

      const buttonclose = eventBlock.querySelector(".close");
      buttonclose.addEventListener("click", function(){
        let data = [];

        if(localStorage.getItem(eventName) != null){
          data = JSON.parse(localStorage.getItem(eventName));
        }

        const todayStr = new Date().toISOString().split("T")[0];
        data.push(todayStr);
        localStorage.setItem(eventName, JSON.stringify(data));

        eventBlock.remove();
      });
    }
  
  }
});

// Vérifie dans le localStorage que la date d'aujourd'hui ne figure pas parmis la checklist de l'event concerné 
function shouldListenEventToday(name) {
  if (localStorage.getItem(name) == null) {
    return true;
  }

  const data = JSON.parse(localStorage.getItem(name));
  const todayStr = new Date().toISOString().split("T")[0];

  return !data.includes(todayStr);
}